import { withNavigationWatcher } from './contexts/navigation';

import SupportDashboard from './pages/support/dashboard/SupportDashboard';
import NewTicketPage from './pages/support/new-ticket/NewTicketPage';
import CannedResponsesPage from './pages/support/canned-responses/CannedResponsesPage';


import UsersPage from './pages/users/UsersPage';
import TicketPage from './pages/support/messages/TicketPage';

import SurveysPage from './pages/support/surveys/SurveysPage';
import TeamChatPage from './pages/support/team-chat/TeamChatPage';
import { t } from 'i18next';
import { ThemeList } from './pages/settings/themeSetting/themeList';
import { ManagementLogs } from './pages/support/logs/logList';
import ComingSoonPage from './pages/support/coming-soon/ComingSoonPage';
import SlaReportPage from './pages/support/reports/SlaReportPage';
import OrganizationsPage from './pages/support/organizations/OrganizationsPage';
import ContactsPage from './pages/support/contacts/ContactsPage';
import FormsPage from './pages/support/forms/FormsPage';
import ChannelsPage from './pages/support/channels/ChannelsPage';
import GeneralSettingsPage from './pages/settings/general/GeneralSettingsPage';
import AgentPerformancePage from './pages/support/reports/AgentPerformancePage';
import ProductsPage from './pages/support/products/ProductsPage';
import TeamsPage from './pages/support/teams/TeamsPage';
import TicketAnalysisPage from './pages/support/reports/TicketAnalysisPage';
import RolesPage from './pages/support/roles/RolesPage';
import WorkflowsPage from './pages/support/workflows/WorkflowsPage';
import IntegrationsPage from './pages/support/integrations/IntegrationsPage';
// Logo modulu (self-contained — src/modules/logo). Tasirken bu satir + asagidaki route ve nav girisi yeterli.
import {
  LogoCustomersPage, LogoMaterialsPage, LogoSuppliersPage, LogoSalesPricesPage,
  LogoPurchasePricesPage, LogoWarehouseParamsPage, LogoOrdersPage,
} from './modules/logo';

// Menude yer alan ama henuz ekrani gelistirilmemis moduller.
// Tiklayinca dashboard'a sekmesin diye gecici "yakinda" sayfasina baglanir.
// Bir modul gerceklesince ilgili path'i asagidaki routes listesine tasi.
const placeholderPaths = [
  '/support/announcements',
];

const placeholderRoutes = placeholderPaths.map((path) => ({
  path,
  element: ComingSoonPage,
  title: () => t('comingSoon'),
}));

export const routes = [
  {
    path: '/support/dashboard',
    element: SupportDashboard,
    title: () => t('support') + " - " + t('dashboard')
  },

  {
    path: '/support/new-ticket',
    element: NewTicketPage,
    title: () => t('support') + " - " + t('new-ticket')
  },
  {
    path: '/support/canned-responses',
    element: CannedResponsesPage,
    title: () => t('support') + " - " + t('canned-responses')
  },

  
  
  {
    path: '/vendor-management/users',
    element: UsersPage,
    title: () => t('vendor-management') + " - " + t('users')
  },
  
  {
    path: '/support/tickets',
    element: TicketPage,
    title: () => t('support') + " - " + t('tickets')
  },
  {path:'/settings/theme',
    element:ThemeList,
    title: () => t('themes')
  },
  {
    path: '/settings/general',
    element: GeneralSettingsPage,
    title: () => t('settings') + " - " + t('generalSettings')
  },
  
  {
    path: '/support/surveys',
    element: SurveysPage,
    title: () => t('support') + " - " + t('surveyTitle')
  },

  {
    path: '/support/team-chat',
    element: TeamChatPage,
    title: () => t('support') + " - " + t('teamChat')
  },
  {
    path: '/support/logs',
    element: ManagementLogs,
    title: () => t('support') + " - " + t('logs')
  },
  {
    path: '/support/reports/sla',
    element: SlaReportPage,
    title: () => t('support') + " - " + t('slaReportTitle')
  },
  {
    path: '/support/reports/agent-performance',
    element: AgentPerformancePage,
    title: () => t('support') + " - " + t('agentPerformance')
  },
  {
    path: '/support/reports/tickets',
    element: TicketAnalysisPage,
    title: () => t('support') + " - " + t('ticketAnalysis')
  },
  {
    path: '/support/organizations',
    element: OrganizationsPage,
    title: () => t('support') + " - " + t('organizations')
  },
  {
    path: '/support/contacts',
    element: ContactsPage,
    title: () => t('support') + " - " + t('contacts')
  },
  {
    path: '/support/products',
    element: ProductsPage,
    title: () => t('support') + " - " + t('products')
  },
  {
    path: '/support/teams',
    element: TeamsPage,
    title: () => t('support') + " - " + t('teams')
  },
  {
    path: '/support/roles',
    element: RolesPage,
    title: () => t('support') + " - " + t('roles')
  },
  {
    path: '/support/forms/request-forms',
    element: FormsPage,
    title: () => t('support') + " - " + t('requestForms')
  },
  {
    path: '/support/forms/fields',
    element: FormsPage,
    title: () => t('support') + " - " + t('fields')
  },
  {
    path: '/support/forms/ticket-types',
    element: FormsPage,
    title: () => t('support') + " - " + t('ticketTypes')
  },
  {
    path: '/support/channels/portal',
    element: ChannelsPage,
    title: () => t('support') + " - " + t('channelPortal')
  },
  {
    path: '/support/channels/email',
    element: ChannelsPage,
    title: () => t('support') + " - " + t('email')
  },
  {
    path: '/support/channels/widget',
    element: ChannelsPage,
    title: () => t('support') + " - " + t('channelWidget')
  },
  {
    path: '/support/channels/whatsapp',
    element: ChannelsPage,
    title: () => t('support') + " - " + t('channelWhatsapp')
  },
  {
    path: '/support/channels/telegram',
    element: ChannelsPage,
    title: () => t('support') + " - " + t('channelTelegram')
  },
  {
    path: '/support/automation/workflows',
    element: WorkflowsPage,
    title: () => t('support') + " - " + t('workflows')
  },
  {
    path: '/support/automation/rules',
    element: WorkflowsPage,
    title: () => t('support') + " - " + t('rules')
  },
  {
    path: '/support/automation/webhooks',
    element: WorkflowsPage,
    title: () => t('support') + " - " + t('webhooks')
  },
  {
    path: '/support/automation/n8n',
    element: WorkflowsPage,
    title: () => t('support') + " - " + t('n8n')
  },
  {
    path: '/settings/integrations',
    element: IntegrationsPage,
    title: () => t('settings') + " - " + t('integrations')
  },
  {
    path: '/logo/customers',
    element: LogoCustomersPage,
    title: () => 'Logo - ' + t('logoCustomers')
  },
  {
    path: '/logo/materials',
    element: LogoMaterialsPage,
    title: () => 'Logo - ' + t('logoMaterials')
  },
  {
    path: '/logo/suppliers',
    element: LogoSuppliersPage,
    title: () => 'Logo - ' + t('logoSuppliers')
  },
  {
    path: '/logo/sales-prices',
    element: LogoSalesPricesPage,
    title: () => 'Logo - ' + t('logoSalesPrices')
  },
  {
    path: '/logo/purchase-prices',
    element: LogoPurchasePricesPage,
    title: () => 'Logo - ' + t('logoPurchasePrices')
  },
  {
    path: '/logo/warehouse-params',
    element: LogoWarehouseParamsPage,
    title: () => 'Logo - ' + t('logoWarehouseParams')
  },
  {
    path: '/logo/orders',
    element: LogoOrdersPage,
    title: () => 'Logo - ' + t('logoOrders')
  },
  ...placeholderRoutes,
];

export const appRoutes = routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
